/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Next_DescInputs */

const en_wc_tut_next_desc = /** @type {(inputs: Wc_Tut_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions or a bug? The ArtCraft Discord is the fastest place to ask, and GitHub issues are where bugs get fixed.`)
};

/**
* | output |
* | --- |
* | "Questions or a bug? The ArtCraft Discord is the fastest place to ask, and GitHub issues are where bugs get fixed." |
*
* @param {Wc_Tut_Next_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_next_desc = /** @type {((inputs?: Wc_Tut_Next_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Next_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_next_desc(inputs)
});
export { wc_tut_next_desc as "wc.tut.next_desc" }